var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGermany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1527_1659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.995117 21.8986C3.25581 27.9913 9.12049 32.3334 15.9999 32.3334C22.8794 32.3334 28.7441 27.9913 31.0047 21.8986L15.9999 20.5073L0.995117 21.8986Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 0.333374C9.12049 0.333374 3.25581 4.67537 0.995117 10.7682L15.9999 12.1594L31.0047 10.7681C28.7441 4.67537 22.8794 0.333374 15.9999 0.333374Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.995188 10.7682C0.352063 12.5015 0 14.3763 0 16.3334C0 18.2905 0.352063 20.1653 0.995188 21.8986H31.0049C31.648 20.1653 32 18.2905 32 16.3334C32 14.3763 31.648 12.5015 31.0048 10.7682H0.995188Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1527_1659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.333374)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGermany);
export default __webpack_public_path__ + "static/media/germany.798c12a7e7256006de5f467970517577.svg";
export { ForwardRef as ReactComponent };